import { AgRendererComponent } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';
import { Component } from '@angular/core';

@Component({
	selector: 'cv-description-renderer',
	templateUrl: './description-renderer.component.html',
	styleUrls: ['./description-renderer.component.scss'],
})
export class DescriptionCellRendererComponent implements AgRendererComponent {
	params: ICellRendererParams;
	searchFilter: string;
	minSearchLength = 2;

	constructor() { 
	}

	agInit(params: ICellRendererParams) {
		this.params = params;
		this.searchFilter = this.params.context?.contextUtil?.getFilterText();
	}

	refresh(params: ICellRendererParams) {
		this.params = params;
		this.searchFilter = this.params.context?.contextUtil?.getFilterText();
		return true;
	}
}
